import { useCallback, useContext } from 'react';
import type { ClEventName } from '@/common/interfaces/customerLabs.interface';
import { UTMContext } from '@/common/context/UTMContext';
import { useAppSelector } from '@/store/hooks';
import { buildClDataLayer } from '@/CustomerLabs/ClUtils';

export const useBuildCommonDataLayer = () => {
  const utmParams = useContext(UTMContext);
  const { user } = useAppSelector((state) => state.user);

  return useCallback(
    (action: ClEventName) => buildClDataLayer(action, user, utmParams),
    [user, utmParams]
  );
};
